import { colors, sizes } from '@lmc/common/constants'
import { Button } from '@lmc/ui-kit'
import { find } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Actions from '../../../../actions'
import { getNominative } from '../../../../common/utils'
import { ResidentQuoteBox } from '../../../../components/carePlans'
import InitialAssessmentCompleteForm from '../../../../components/forms/screens/InitialAssessmentCompleteForm'
import { Spinner } from '../../../../components/generic'
import Operations from '../../../../operations'
import { history } from '../../../../store'
import { withRouter } from '../../../../withRouter'

export class ResidentInitialAssessmentCompleteScreen extends React.Component {
  componentDidMount() {
    const { resident, addForm } = this.props
    if (resident) addForm({ resident })
  }

  componentDidUpdate(prevProps) {
    const { addForm, resident } = this.props
    if (!prevProps.resident && resident) {
      addForm({ resident })
    }
  }

  handleSubmit = () => {
    const {
      createCarePlan,
      router: { params }
    } = this.props
    createCarePlan({
      url: `list/residents/${params.id}/createCarePlan`,
      onComplete: this.handleComplete
    })
  }

  handleComplete = () => {
    const {
      fetchResident,
      router: { params }
    } = this.props
    fetchResident(params.id)
    history.push(`/residents/${params.id}/care-plans`)
  }

  renderBackButton = () => {
    const {
      router: {
        params: { id }
      }
    } = this.props
    return (
      <Link to={`/residents/${id}/initial-assessments`}>
        <span className="octicon octicon-chevron-left" /> Back
      </Link>
    )
  }

  renderFooter = () => {
    const { form } = this.props
    const disabled = !form || !form.fields || !form.fields.residentAccepted
    return (
      <div
        className="lmc-fixed-footer"
        style={{
          ...styles.footer
        }}
      >
        <Button
          id="finalise-initial-assessment"
          disabled={disabled}
          onClick={this.handleSubmit}
          style={styles.button}
          variant="primary"
        >
          Finalise Initial Assessment
        </Button>
      </div>
    )
  }

  render() {
    const {
      features,
      router: { params },
      resident,
      carePlanNominative,
      preferredPeopleNominative
    } = this.props
    if (!features || !params || !resident) return <Spinner />
    return (
      <div style={styles.wrapper}>
        <div style={styles.mainContainer}>
          {this.renderBackButton()}
          <ResidentQuoteBox
            resident={resident}
            style={styles.quoteBox}
            text={getResidentBoxText(carePlanNominative)}
          />
          <div style={styles.formContainer}>
            <InitialAssessmentCompleteForm
              features={features}
              preferredPeopleNominative={preferredPeopleNominative}
            />
          </div>
        </div>
        {this.renderFooter()}
      </div>
    )
  }
}

const styles = {
  button: {
    background: colors.green,
    color: 'white',
    padding: '0px 25px',
    textShadow: 'none',
    marginRight: 20
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw'
  },
  formContainer: {
    marginTop: 25
  },
  mainContainer: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    padding: '20px 20px 100px 20px',
    flex: 1
  },
  quoteBox: {
    marginTop: 24
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }
}

const FORM_ID = 'completeInitialAssessment'
const getResidentBoxText = (carePlanNominative) =>
  `You can now finalise my Initial Assessment, which will create my ${getNominative(
    carePlanNominative,
    'Care Plan'
  )}.`

ResidentInitialAssessmentCompleteScreen.propTypes = {
  createCarePlan: PropTypes.func.isRequired,
  features: PropTypes.object,
  fetchResident: PropTypes.func.isRequired,
  form: PropTypes.object,
  resident: PropTypes.object
}

const mapStateToProps = (state, props) => {
  const id = props.router.params && props.router.params.id
  return {
    form: state.forms[FORM_ID],
    resident: find(state.data.residents, { id }),
    features: state.global.home,
    carePlanNominative: state.global.home.preferredCarePlansNominative,
    preferredPeopleNominative: state.global.home.preferredPeopleNominative
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addForm: (data) => dispatch(Actions.addForm({ data, formId: FORM_ID })),
    createCarePlan: (data) =>
      dispatch(
        Operations.postItem({ ...data, formId: FORM_ID, method: 'POST' })
      ),
    fetchResident: (id) => dispatch(Operations.loadListItem('residents', id))
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ResidentInitialAssessmentCompleteScreen)
)
